<template>
    <div v-loading="loading" class="card" v-for="(item, index) in displayedList" :key="index">
        <div class="content" @click="goToDetail(item)">
            <div class="image-container">
                <img class="image" :src="item.contentImg[0]" alt="">
            </div>
            <div class="title">{{ item.contentTitle }}</div>
            <div class="tips-container">
                <span class="tips" v-for="(tag, tagIndex) in item.tips" :key="tagIndex">{{ tag }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { ref, onMounted, defineProps, computed} from 'vue';
const loading = ref(false)
import { useStore } from '@/store/index';
const store = useStore();

const props = defineProps({
    categoryId: {
        type: String,
        required: true,
    },
    isShow: {
        type: Boolean,
        required: true,
    }
});

const list = ref([])
const tags = ref([])

const displayedList = computed(() => {
    return props.isShow ? list.value : list.value.slice(0, 6);
});


onMounted(() => {
     getInfo();
 });

const router = useRouter();
const goToDetail = (item) => {
    
    router.push({ 
        path: '/caseDetail',
        query:{currentId: item.id, categoryId: props.categoryId}
    });
};


const getInfo = async () => {
    loading.value = true
    const _solutionsData = store.allData['/solutions']
    list.value = _solutionsData?.filter(v => v.contentType !== 'banner');
    await getTags(); // 获取标签
    loading.value = false
 };

 const getTags = async () => {
     tags.value = store.allTag
     list.value.forEach(item => {
         const matchedLabels = tags.value
             .filter(tag => item.contentTags.includes(tag.dictValue))
             .map(tag => tag.dictLabel);
         item.tips = matchedLabels;
     });
 };

</script>

<style scoped lang="less">
.card {
    width: calc(100% / 3 - calc(16 * var(--groot-ui-rpx)));
    margin: 0 calc(8 * var(--groot-ui-rpx)) calc(20 * var(--groot-ui-rpx));
    border-radius: calc(4 * var(--groot-ui-rpx));
    overflow: hidden;
    box-shadow: 0 calc(2 * var(--groot-ui-rpx)) calc(10 * var(--groot-ui-rpx)) rgba(0, 0, 0, 0.11);
    cursor: pointer;
    background-color: #FFF;
    transition: all 0.5s;
}

.content {
    padding: calc(20 * var(--groot-ui-rpx))
}

.title {
    margin: calc(24 * var(--groot-ui-rpx)) 0 calc(8 * var(--groot-ui-rpx));
    color: #333;
    font-weight: bold;
    font-size: calc(20 * var(--groot-ui-rpx));
    position: relative;
    text-align: left;

    &:after {
        content: "";
        width: calc(4 * var(--groot-ui-rpx));
        height: calc(20 * var(--groot-ui-rpx));
        position: absolute;
        top: 50%;
        margin-top: calc(-10 * var(--groot-ui-rpx));
        left: calc(-13 * var(--groot-ui-rpx));
        background-color: #126324;
    }
}

.tips-container {
    display: flex;
    margin-bottom: calc(14 * var(--groot-ui-rpx));
    flex-wrap: wrap;
}

.tips {
    padding: calc(3 * var(--groot-ui-rpx)) calc(6 * var(--groot-ui-rpx));
    margin-top: calc(6 * var(--groot-ui-rpx));
    margin-right: calc(3 * var(--groot-ui-rpx));
    font-size: calc(12 * var(--groot-ui-rpx));
    color: #126324;
}

.card:hover .title {
    color: #126324;
}

.image-container {
    width: 100%;
    overflow: hidden;
    height: calc(252 * var(--groot-ui-rpx));
    border-radius: calc(4* var(--groot-ui-rpx));
}

.image {
    width: 100%;
    height: 100%;
    transition: transform 0.5s;
    object-fit: cover;
}

.card:hover .image {
    transform: scale(1.1);
}
</style>
